"use client"

import { Separator, Text } from "@/elements"
import { NovaWordmark } from "@/svg"
import ArrowLeftIcon from "@heroicons/react/24/outline/ArrowLeftIcon"
import type { FC } from "react"
import type { SubscriptionPlan } from "../useSubscriptionCheckoutModal"
import { Benefits } from "./Benefits"
import { SubscriptionCheckoutWrapper } from "./CheckoutWrapper"
import { ProBadge } from "./ProBadge"
import { TrustedBy } from "./TrustedBy"

interface Props {
  onClickBack: () => void
  subscriptionPlans: SubscriptionPlan[]
  singlePurchasePlans: SubscriptionPlan[]
  selectedPlanId: string | null
  eligibleForFreeTrial: boolean
  setStep: (step: number) => void
  selectedProductType: "daily" | "monthly" | "yearly" | null
  setIsModalLocked: (canModalClose: boolean) => void
  setSelectedProductType: (productType: "daily" | "monthly" | "yearly" | null) => void
  additionalOnSuccess?: () => void
}

export const StepTwo: FC<Props> = ({
  onClickBack,
  setStep,
  selectedPlanId,
  subscriptionPlans,
  singlePurchasePlans,
  eligibleForFreeTrial,
  selectedProductType,
  setIsModalLocked,
  setSelectedProductType,
  additionalOnSuccess,
}) => {
  const selectedPlan = [...subscriptionPlans, ...singlePurchasePlans].find(plan => plan.priceId === selectedPlanId)

  return (
    <div className="grid w-full grid-cols-12 gap-0">
      <div className="col-span-12 lg:col-span-6">
        <div className="flex flex-col lg:pl-10">
          <div className="mb-6 mt-3 w-fit cursor-pointer" onClick={onClickBack}>
            <ArrowLeftIcon className="size-[24px]" />
          </div>
          <div className="flex flex-row items-center gap-2">
            <NovaWordmark width={82} height={21} />
            <ProBadge />
          </div>
          <Text variant="h5" className="mt-6">
            Gain access to top industry jobs and get hired faster.
          </Text>
          <div className="my-8 rounded-xl bg-bg-2 py-6">
            <div className="px-6">
              <Text variant="body2" className="mb-3 text-fg-2">
                {selectedPlan?.stepTwoDescription}
              </Text>
              <Text variant="h5">{selectedPlan?.priceDisplay}</Text>
            </div>
            <Separator className="my-5 hidden bg-bg-3 lg:flex" />
            <div className="hidden flex-col px-6 lg:flex">
              <Benefits />
            </div>
          </div>
          <div className="hidden w-full lg:flex">
            <TrustedBy />
          </div>
        </div>
      </div>
      <div className="col-span-12 lg:col-span-6">
        <div className="mb-8 h-full lg:mb-0 lg:pl-10 lg:pr-5">
          <div className="min-h-[324px] rounded-xl border border-bg-3 p-5 lg:h-full">
            <SubscriptionCheckoutWrapper
              setStep={setStep}
              setIsModalLocked={setIsModalLocked}
              eligibleForFreeTrial={eligibleForFreeTrial}
              selectedPlanId={selectedPlanId}
              selectedProductType={selectedProductType}
              setSelectedProductType={setSelectedProductType}
              additionalOnSuccess={additionalOnSuccess}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
